import formatTableJson from '@/config/tableComponentParams.js'
import { onOffLineTag } from '@/config/tag'
import i18n from '@/locales/index'
export default formatTableJson([
  {
    filed: 'createTime',
    type: 'time',
    label: i18n.t('Device.onlineTime'),
    width: '200px'
  },
  {
    filed: 'online',
    label: i18n.t('Device.action'),
    type: 'tag',
    colorList: onOffLineTag,
    formatFn: function(_, row) {
      return row.onlineName
    }
  }
])
